module.exports = __webpack_public_path__ + "static/media/home5.954bbd3b.jpg";